

<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <table-search
        :style="{ float: 'right' }"
        add-text="新增计划"
        :addbtn-is-show="$role === 0"
        @onSearch="onSearch"
        @onChangecompany="onChangecompany"
        @editAndAdd="editAndAdd"
      />
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: (total) => `共${total}条`,
        }"
        @change="changePage"
      >
        <template slot="status" slot-scope="status">
          {{ status === 2 ? "已完成" : "待提交" }}
        </template>
        <template slot="operation" slot-scope="text, record">
          <popconfirm-button
            v-show="record.status === 0 && $role === 0"
            text="确认"
            alert-title="确定提交计划？"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider
            v-show="record.status === 0 && $role === 0"
            type="vertical"
          />
          <a
            v-show="record.status === 0 && $role === 0"
            href="javascript:;"
            @click="() => editAndAdd(record)"
            >修改</a
          >

          <a
            v-show="record.status === 2"
            href="javascript:;"
            @click="() => action(record)"
            >查看</a
          >
          <a-divider v-if="record.status === 2" type="vertical" />
          <a
            v-show="record.status === 2"
            href="javascript:;"
            :disabled="record.pass_report_total == 0"
            @click="() => downloadReport(record)"
            >下载报告</a
          >
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import { columns } from "./data/index.js";
import TableSearch from "./components/TableSearch";
export default {
  components: { TableSearch },
  data() {
    return {
      selectData: [],
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      hospitalVisible: false,
      keyword: "",
      operations: [],
      downloadUrl: "",
      token: "",
      company_id: "",
    };
  },
  created() {
    this.$role = this.$store.state.user.role;
    this.token = localStorage.getItem("token");
  },
  mounted() {
    this.getCompanyList();
  },
  methods: {
    // 获取合作企业
    async getCompanyList() {
      let result = await this.$http.post("/Company/getCooperationCompanyList");
      if (result.data.status === 1) {
        this.company_id = result.data.data.data_list[0].id;
        // 获取表格数据
        this.getTableData({
          sign_mode: "1",
          keyword: this.keyword,
          page: String(this.current),
          pageSize: String(this.pageSize),
          cooperation_company_id: this.company_id,
        });
      }
    },
    // 下载报告
    downloadReport(record) {
      window.open(
        `${this.uploadUrl}WorkReport/workReportExportWordByAgreement?agreement_id=${record.id}&token=${this.token}`
      );
    },
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post("/agreement/getList", params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        this.current = Number(params.page);
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            title: item.title,
            qichacha_name1: item.company_info.team_name,
            qichacha_name2:
              item.service_provider_info.companyInfo.qichacha_name,
            link_products: item.agreement_product
              .map((item) => {
                return item.title;
              })
              .join("、"),
            location: item.path_txt,
            service_start_time: this.$moment
              .unix(item.service_start_time)
              .format("YYYY-MM-DD"),
            service_end_time: this.$moment
              .unix(item.service_end_time)
              .format("YYYY-MM-DD"),
            status: item.status,
            pass_report_total: item.pass_report_total,
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    onChangecompany(value) {
      this.current = 1;
      this.company_id = value;
      this.getTableData({
        sign_mode: "1",
        page: String(this.current),
        pageSize: String(this.pageSize),
        cooperation_company_id: this.company_id,
      });
    },
    // 搜索
    async onSearch(value) {
      this.keyword = value;
      this.current = 1;
      // 获取表格数据
      await this.getTableData({
        sign_mode: "1",
        keyword: this.keyword,
        page: this.current,
        pageSize: String(this.pageSize),
        cooperation_company_id: this.company_id,
      });
    },
    // 新增  编辑
    editAndAdd(record) {
      if (record) {
        this.$router.push({
          path: "/agreement/edit",
          query: { id: record.id },
        });
      } else {
        this.$router.push({
          path: "/agreement/add",
        });
      }
    },
    // 查看
    async action(record) {
      this.$router.push({
        path: "/agreement/details",
        query: { id: record.id },
      });
    },
    // 企业确认提交
    async onConfirm(record) {
      let result = await this.$http.post("/agreement/confirm", {
        id: record.id,
        flag: "1",
      });
      if (result.data.status === 1) {
        this.getTableData({
          sign_mode: "1",
          keyword: this.keyword,
          page: String(this.current),
          pageSize: String(this.pageSize),
          cooperation_company_id: this.company_id,
        });
        this.$message.success("操作成功！");
      }
    },
    // 分页
    changePage(pagination) {
      this.current = pagination.current;
      this.getTableData({
        sign_mode: "1",
        keyword: this.keyword,
        page: String(pagination.current),
        pageSize: String(pagination.pageSize),
        cooperation_company_id: this.company_id,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
}
</style>